export const BRAND_LOGOS = { "Sherwin-Williams": "/brands/sherwin-williams.png", Killing: "/brands/killing.png" };

export const FAMILIES = ["Blancos", "Neutros", "Azules", "Verdes", "Rojos", "Amarillos", "Oscuros"];

export const isLight = (hex) => {
  const c = (hex || "#ffffff").replace("#", "");
  const r = parseInt(c.slice(0, 2), 16), g = parseInt(c.slice(2, 4), 16), b = parseInt(c.slice(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 160;
};
